'use client';

import {
  type FilterOptions,
  ProductListingPagination,
  useProductListingFilters,
  useProductListingSortState,
} from '@veranda/shared/components/pages/product-listing';
import {
  type ProductListingPageBaseProps,
  usePrefetchProductListingProducts,
  useProductListingPageCount,
} from '@veranda/shared/components/pages/product-listing/client';
import { useTransition } from 'react';

export function Pagination({
  slug,
  data,
  filterOptions,
}: {
  slug: string;
  data: ProductListingPageBaseProps;
  filterOptions: FilterOptions[];
}) {
  const [_, startTransition] = useTransition();
  const { filterValues } = useProductListingFilters({
    filterOptions,
    startTransition,
  });
  const { sort } = useProductListingSortState(data.sortOrder);
  const { data: pageCount } = useProductListingPageCount({
    slug,
    settings: data.settings,
    filterValues,
  });
  const prefetchProductListingProducts = usePrefetchProductListingProducts();

  function prefetchPage(pageNumber: number) {
    prefetchProductListingProducts({
      slug,
      currentPage: pageNumber,
      sort,
      settings: data.settings,
      filterValues,
    });
  }

  return (
    <ProductListingPagination
      prefetchPage={prefetchPage}
      pageCount={pageCount ?? 1}
      slug={slug}
      className="[--color:hsl(var(--color-brand-burgundy))] "
    />
  );
}
